import { render, staticRenderFns } from "./activity-join.vue?vue&type=template&id=481df9d2&scoped=true&"
import script from "./activity-join.vue?vue&type=script&lang=js&"
export * from "./activity-join.vue?vue&type=script&lang=js&"
import style0 from "./activity-join.vue?vue&type=style&index=0&id=481df9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481df9d2",
  null
  
)

export default component.exports